"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _StaticHtml = _interopRequireDefault(require("./StaticHtml"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// this is considered dangerous (so developer should use it with caution)
// but if the html is static (in this case it is), it would not be a problem
var CookieConsentContainer = function CookieConsentContainer() {
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'fixed',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      zIndex: 1000,
      backgroundColor: '#f9f9f9',
      overflow: 'hidden'
    },
    dangerouslySetInnerHTML: {
      __html: _StaticHtml.default
    }
  });
};
var _default = exports.default = CookieConsentContainer;